'use client';
import dynamic from 'next/dynamic';
import type { ComponentType } from 'react';
import type { StockMapProps } from '../createStockPage';
import { StockMapLoading } from '../stockMapLoading';

// Client-only + lazy (mapbox + recharts run browser-only). ssr:false must live
// in a client component; the cast restores the prop type next/dynamic widens.
const ElantranInventoryMap = dynamic(
  () => import('./elantranMap').then((m) => m.ElantranInventoryMap),
  {
    ssr: false,
    loading: () => <StockMapLoading />,
  },
);

export default ElantranInventoryMap as ComponentType<StockMapProps>;
